import Cookies from "js-cookie";

const Product = {
  init: function () {
    this.events();
  },

  events: function () {
    $(".accordion__button").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);
      let content = btn.next();
      content.slideToggle();
      btn.toggleClass("accordion__button--open");
    });

    $(".popup").on("click", ".aptaclub-yes", function () {
      Cookies.set("aptaclub_disclaimer", true, {
        expires: 365,
      });
    });
  },
};

export default Product;
